import { model } from "core/util";
import { ChangeResponseDto, ChangeResponseType } from "types";

export const ChangeResponse = model.createModel<ChangeResponseDto, ChangeResponseType>((json) => ({
    status: json.status,
    error: json.error,
    message: json.message,
}));
